export default __webpack_public_path__ + "static/media/minus.f8fcbf0a.svg";